import React, {useState} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { GetSortPlanResource } from '../resources/GetSortPlanResource';
import { getNodeId, downloadCsvFromUrl} from '../Utility';
import {FormattedMessage} from "react-intl";
import { FileType } from '../enums';
import {FEATURES} from "../constants";
import Loader from "@amzn/meridian/loader";



/**
 * Button component for downloading sort plan data in CSV format.
 * Gets the nodeId from query parameters and cycleId from Redux state.
 */
const DownloadSortPlanButton = ({selectedCycle, featureStatus}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async () => {
        try {
            setIsLoading(true);
            const nodeId = getNodeId();
            const cycleId = selectedCycle;
            const fileType = FileType.CSV;
            const response = await GetSortPlanResource(nodeId, cycleId, fileType);
            const today = new Date();
            const dateStr = today.toISOString().split('T')[0]
            const filename = `SortPlan-${nodeId}-${cycleId}-${dateStr}.csv`;
            await downloadCsvFromUrl(response.data.sortPlanMetadataPresignedS3Url, filename);
        } finally {
            setIsLoading(false);
        }
    };

    if (!featureStatus || !featureStatus[FEATURES.DOWNLOAD_SORT_PLAN_BUTTON_VISIBILITY]) {
        return null;
    }

    return (
        <div className="download-sort-plan-container">
            <span
                onClick={isLoading ? null : handleClick}
                className={`download-sort-plan-link ${isLoading  ? 'disabled' : ''}`}
                data-cy="downloadSortPlanBtn"
            >
                {isLoading ? (
                    <Loader size="small" />
                ) : (
                    <FormattedMessage id="stow.download_sort_location_plan" defaultMessage="Download-sort-location-plan"/>
                )}
            </span>
        </div>
    );
}

const mapStateToProps = (state) => ({
    selectedCycle: state.optionsReducer.options.cycle,
    cycleId: state.optionsReducer.options.cycleId,
    featureStatus: state.configReducer.featureStatus
});

export default withRouter(connect(mapStateToProps)(DownloadSortPlanButton));


// WEBPACK FOOTER //
// ./src/components/DownloadSortPlanButton.js